import type { Editor } from "@tiptap/core";
import { findBlock, locateBlockById } from "../../domain/find";
import { getEditorStore } from "../../domain/store";
import { emailBuilderRichTextSessionBlockId } from "./emailBuilderRichTextSession";

export const HEADING_FONT_WEIGHT_BOLD = 700;
const HEADING_FONT_WEIGHT_REGULAR = 400;

export function toggleEmailBuilderHeadingWeight(editor: Editor): boolean {
  const blockId = emailBuilderRichTextSessionBlockId(editor);
  if (blockId === null) {
    return false;
  }

  const document = getEditorStore().document;
  const located = locateBlockById(document, blockId);
  if (located === undefined) {
    return false;
  }

  const block = findBlock(document, located.rowId, located.columnId, located.blockId);
  if (block?.type !== "text" || block.variant === "normal") {
    return false;
  }

  getEditorStore().updateBlock(located.rowId, located.columnId, located.blockId, {
    fontWeight: block.fontWeight >= HEADING_FONT_WEIGHT_BOLD
      ? HEADING_FONT_WEIGHT_REGULAR
      : HEADING_FONT_WEIGHT_BOLD,
  });
  return true;
}
